// Utility function to load SVG assets in the web app
export const loadSvgAsset = (assetPath: string): string => {
  // In a web app, we can reference assets directly from the public folder
  // The assetPath should be relative to the public folder
  return `/assets/${assetPath}`;
};

// Helper function to create an SVG component
export const createSvgComponent = (assetPath: string) => {
  const SvgComponent = (props: React.ImgHTMLAttributes<HTMLImageElement>) => {
    return (
      <img 
        src={loadSvgAsset(assetPath)} 
        alt="" 
        {...props} 
        style={{ ...props.style, maxWidth: '100%', height: 'auto' }} 
      />
    );
  };
  return SvgComponent;
};